import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

// reducers
import { selectJobForDetails } from "../../stores/jobs";

const timelapse = (date) => {
  const minutesLapse = moment().diff(date, 'minutes');

  if (minutesLapse <= 60) return `${moment().diff(date, 'minutes')} minutes`;
  if (minutesLapse > 60 && minutesLapse <= 1440) return `${moment().diff(date, 'hours')} hours`;

  return `${moment().diff(date, 'days')} days`;
}

export const KanbanCardJob = (props) => {
  // input
  const {
    user_id,
    job_id,
    product,
    premise,
    escalated = false,
  } = props;

  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div
      className={`flex-shrink-0 w-48 md:w-auto bg-white rounded-lg cursor-pointer ${
        escalated
          ? "animate-pulse border-2 border-red-500 shadow-lg shadow-red-200"
          : "border border-slate-200 shadow-md"
      }`}
      onClick={() => {
        dispatch(selectJobForDetails(null));
        navigate(`/jobs/details?user_id=${user_id}&job_id=${job_id}`);
      }}
    >
      {/* Detailed view for larger screens */}
      <div className="hidden md:block">
        <div className="flex flex-row">
          {/* Job card label */}
          <CardLabel product={product} />

          {/* Job card content */}
          <div className="flex flex-col min-h-24">
            {/* Job card header */}
            <div className="h-4"></div>
            {/* Job body */}
            <div className="grow px-2">
              {escalated && (
                <div className="mb-2 rounded bg-red-600 px-2 py-1 text-xs font-bold text-white">
                  ⚠ Partner arrival overdue
                </div>
              )}

              <h3 className="mb-2 text-sm text-blue-500 font-bold underline">
                Job: {job_id}
              </h3>
              <div
                className={`py-2 flex flex-row items-center space-x-2 text-lochinvar-950`}
              >
                {/* <GlobeAsiaAustraliaIcon className="flex-none h-4 w-4" /> */}
                <div className="flex flex-col">
                  <p className="flex-auto text-xs font-regular">{premise?.address?.address1}</p>
                  <p className="flex-auto text-xs font-regular">{premise?.place?.municipality}, {premise?.place?.region}</p>
                </div>
              </div>

              <TimeLapse {...props} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CardLabel = ({ product }) => {
  const title = product.metadata.title;

  if (product.metadata.subtype === 'faulty' || product.metadata.subtype === 'sitevisit') return (
    <div
      className={`flex flex-col w-8 items-center justify-center bg-copperrust-600 rounded-l`}
    >
      <span
        className={`text-sm transform -rotate-90 whitespace-nowrap text-copperrust-50`}
      >
        {title}
      </span>
    </div>
  )

  return (
    <div
      className={`flex flex-col w-8 items-center justify-center bg-lochinvar-600 rounded-l`}
    >
      <span
        className={`text-sm transform -rotate-90 whitespace-nowrap text-lochinvar-50`}
      >
        {title}
      </span>
    </div>
  )
}

const TimeLapse = (props) => {
  const { status } = props;
  const data = {
    label: 'Time lapsed since payment',
    value: timelapse(props.technician_lookup_starttime)
  }

  switch (status) {
    case 'TECHNICIAN:ASSIGNMENT': {
      data.label = 'Time lapsed since payment';
      data.value = timelapse(props.technician_lookup_starttime);
      break;
    }
    case 'JOB:ROUTE:CREATED': {
      data.label = 'Time lapsed since start navigation';
      data.value = timelapse(props.JOB_ROUTE_INPROGRESS);
      break;
    }
    case 'JOB:WORK:INPROGRESS': {
      data.label = 'Time lapsed since start working';
      data.value = timelapse(props.JOB_WORK_INPROGRESS);
      break;
    }
    case 'JOB:COMPLETED:PAYMENT_TRANSFER:PENDING': {
      data.label = 'Time lapsed since job completed';
      data.value = timelapse(props.date_completion);
      break;
    }
    default: break;
  }

  return (
    <div
      className={`mt-2 py-2 flex flex-row items-center space-x-2 text-lochinvar-950 border-t border-slate-200`}
    >
      {/* <ClockIcon className="flex-none h-4 w-4" /> */}
      <div className="flex flex-col">
        <p className="flex-auto text-xs font-light">{data.label}</p>
        <p className="flex-auto text-xs font-bold">{data.value}</p>
      </div>
    </div>
  )
}
